import { Toaster, useId, useToastController } from '@fluentui/react-components'
import { useCallback } from 'react'
import { NotificationToast } from '../components/NotificationToast/NotificationToast'
import { HEADER_HEIGHT } from '../constants/layout'
import type { NotifyParams } from '../contexts/NotificationContext'
import { NotificationContext } from '../contexts/NotificationContext'

interface NotificationProviderProps {
  children: React.ReactNode
}

const NotificationProvider = ({ children }: NotificationProviderProps) => {
  const toasterId = useId('toaster')
  const { dispatchToast } = useToastController(toasterId)

  const notify = useCallback(
    ({ isSuccess, text, position = 'top', link }: NotifyParams) => {
      dispatchToast(<NotificationToast text={text} link={link} />, {
        position,
        intent: isSuccess ? 'success' : 'error',
        timeout: isSuccess ? 3000 : 6000,
      })
    },
    [dispatchToast]
  )

  return (
    <NotificationContext value={{ notify }}>
      {children}
      <Toaster toasterId={toasterId} offset={{ vertical: HEADER_HEIGHT, horizontal: 0 }} />
    </NotificationContext>
  )
}

export { NotificationProvider }
